<template>
  <t-layout :showNav="false">
    <div
      v-if="pageInfo"
      class="page"
      :style="`background-color: ${pageInfo.config.page_back_color};`"
    >
      <div v-for="item in pageInfo.elements" :key="item.eleId" :id="item.eleId">
        <Hotzone
          v-if="item.moduleType === componentType.hotzone"
          :data="item"
          :eventName="eventName"
          :pageId="pageId"
        />
      </div>
    </div>
  </t-layout>
</template>

<script>
import { ComponentType } from './utils/config'
import Hotzone from './components/hotzone/index.vue'

export default {
  name: 'findPageView',
  components: { Hotzone },
  data() {
    return {
      eventName: '发现页',
      componentType: ComponentType,
      pageId: null,
      pageInfo: null
    }
  },
  created() {
    this.pageId = Number(this.$route.query.id)
    this.getPageInfo()
  },
  methods: {
    getPageInfo() {
      // this.$store.commit(
      //   'setUserToken',
      //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjcwMDcyLCJ0cyI6MTY2OTc5ODY1OCwiZXhwIjoxNjY5Nzk4NjU4fQ.KHTioAFv_059eHUmOg2wrjW2-EdiVjoU-noL3Yx6NUg'
      // )
      this.$api.find.getPageInfo({ id: this.pageId }).then(res => {
        this.pageInfo = res.data.data
        const elements = (this.pageInfo && this.pageInfo.elements) || []
        elements.map((item, index) => {
          item.eleId = `ele-${index}`
        })
        console.log('pageInfo', this.pageInfo)

        this.$store.commit('setTitle', this.pageInfo.page_title || '免税购乐帮')

        gio('track', 'page_view', {
          cms_id: this.pageId,
          event_name: this.eventName
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  min-height: calc(100vh - 92rpx);
}
</style>
